import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../../util/api";

//CAROUSELS/COMPONENTS TABLE:
export const getComponents = createAsyncThunk("components/getComponents", async () => {
    const response = await api.get(`v2/api/settings/components`);

    const components = response?.data?.data || [];

    const componentsWithoutTopBanner = components.filter(c => c.type_id !== 4);

    return {components: componentsWithoutTopBanner};
});

export const editComponent = createAsyncThunk("components/editComponent", async ({key, value, id}, {getState}) => {
    const payload = {[key]: value};
    const {
        data: {data = [], message = [{}]},
    } = await api.put(`v2/api/settings/components/${id}`, payload);

    const state = getState();
    const oldComponents = state.homepageSettings.components.components;
    const newComponents = oldComponents.map(comp => (comp.id === data[0].id ? data[0] : comp));

    if (message[0]?.text) {
        return {components: oldComponents, error: message[0].text};
    } else if (!data[0] || !data[0].id) {
        return {components: oldComponents};
    }
    return {components: newComponents};
});

//VIDEOS TABLE:

export const getVideos = createAsyncThunk("topBanner/getVideos", async () => {
    const {
        data: {data = []},
    } = await api.get(`v2/api/settings/components/homepage/videos`);
    return data;
});

export const addVideos = createAsyncThunk("topBanner/addVideos", async videos => {
    const {
        data: {data = []},
    } = await api.post(`v2/api/settings/components/homepage/videos`, {
        videos,
    });

    //TO DO!!!: back should be ready to receive [] of videoIds and return all selected videos (exactly like in trackpage)
    return data;
});

export const editMediaItem = createAsyncThunk("topBanner/editMediaItem", async ({key, value, id}, {getState}) => {
    const payload = {video_id: id, [key]: value};

    const {
        data: {data = {}},
    } = await api.put(`v2/api/settings/components/homepage/videos`, payload);

    const state = getState();
    const oldList = state.homepageSettings.topBannerVideos.videos;
    const newList = oldList.map(video => (video.id === data?.id ? data : video));
    return newList;
});

export const deleteMediaItem = createAsyncThunk("topBanner/deleteMediaItem", async (id, {getState}) => {
    const payload = {data: {video_id: id}};

    const {
        data: {data = {}},
    } = await api.delete(`v2/api/settings/components/homepage/videos`, payload);

    const state = getState();
    const oldList = state.homepageSettings.topBannerVideos.videos;
    const newList = oldList.filter(vid => vid.video_id !== data?.video_id);

    return newList;
});

const initialState = {
    components: {
        components: [],
        status: {
            type: "idle",
            error: null,
        },
    },
    topBannerVideos: {
        videos: [],
        status: {
            type: "idle",
            error: null,
        },
    },
};

const homePageSettingsSlice = createSlice({
    name: "homepageSettings",
    initialState,
    reducers: {
        setInitialState: state => initialState,
    },
    extraReducers: {
        //COMPONENTS:
        //get components:
        [getComponents.pending]: ({components}, action) => {
            components.status.type = "loading";
        },
        [getComponents.fulfilled]: ({components}, action) => {
            components.status.type = "succeeded";
            components.components = action.payload.components;
        },
        [getComponents.rejected]: ({components}, action) => {
            components.status.type = "failed";
            components.status.error = action.error.message;
        },
        //edit component:
        [editComponent.pending]: ({components}, action) => {
            components.status.type = "loading";
        },
        [editComponent.fulfilled]: ({components}, action) => {
            components.status.type = "succeeded";

            components.status.error = action.payload.error || "";
            components.components = action.payload.components;
        },
        [editComponent.rejected]: ({components}, action) => {
            components.status.type = "failed";
            components.status.error = action.error.message;
        },

        //VIDEOS:
        //get videos:
        [getVideos.pending]: ({topBannerVideos}, action) => {
            topBannerVideos.status.type = "loading";
        },
        [getVideos.fulfilled]: ({topBannerVideos}, action) => {
            topBannerVideos.status.type = "succeeded";
            topBannerVideos.videos = action.payload;
        },
        [getVideos.rejected]: ({topBannerVideos}, action) => {
            topBannerVideos.status.type = "failed";
            topBannerVideos.status.error = action.error.message;
        },

        //edit videos:
        [editMediaItem.pending]: ({topBannerVideos}, action) => {
            topBannerVideos.status.type = "loading";
        },
        [editMediaItem.fulfilled]: ({topBannerVideos}, action) => {
            topBannerVideos.status.type = "succeeded";

            topBannerVideos.status.error = action.payload.error || "";
            topBannerVideos.videos = action.payload;
        },
        [editMediaItem.rejected]: ({topBannerVideos}, action) => {
            topBannerVideos.status.type = "failed";
            topBannerVideos.status.error = action.error.message;
        },

        //add videos:
        [addVideos.pending]: ({topBannerVideos}, action) => {
            topBannerVideos.status.type = "loading";
        },
        [addVideos.fulfilled]: ({topBannerVideos}, action) => {
            topBannerVideos.status.type = "succeeded";

            topBannerVideos.status.error = action.payload.error || "";
            topBannerVideos.videos = action.payload;
        },
        [addVideos.rejected]: ({topBannerVideos}, action) => {
            topBannerVideos.status.type = "failed";
            topBannerVideos.status.error = action.error.message;
        },

        //delete video:
        [deleteMediaItem.pending]: ({topBannerVideos}, action) => {
            topBannerVideos.status.type = "loading";
        },
        [deleteMediaItem.fulfilled]: ({topBannerVideos}, action) => {
            topBannerVideos.status.type = "succeeded";

            topBannerVideos.status.error = action.payload.error || "";
            topBannerVideos.videos = action.payload;
        },
        [deleteMediaItem.rejected]: ({topBannerVideos}, action) => {
            topBannerVideos.status.type = "failed";
            topBannerVideos.status.error = action.error.message;
        },
    },
});

export const {setInitialState} = homePageSettingsSlice.actions;
export default homePageSettingsSlice.reducer;

export const selectAllComponents = state => state.homepageSettings.components.components;
export const selectComponentsStatus = state => state.homepageSettings.components.status;

export const selectAllTopBannerVideos = state => state.homepageSettings.topBannerVideos.videos;
export const selectTopBannerVideosStatus = state => state.homepageSettings.topBannerVideos.status;
